export const WarningIcon = () => `
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.2167 0H8.78333L0 8.78333V21.2167L8.78333 30H21.2167L30 21.2167V8.78333L21.2167 0ZM15 23.8333C13.8 23.8333 12.8333 22.8667 12.8333 21.6667C12.8333 20.4667 13.8 19.5 15 19.5C16.2 19.5 17.1667 20.4667 17.1667 21.6667C17.1667 22.8667 16.2 23.8333 15 23.8333ZM16.6667 16.6667H13.3333V6.66667H16.6667V16.6667Z" fill="#FF3B47"/>
  </svg>
`
